/* eslint-disable import/no-named-as-default-member */
import Cookies from 'js-cookie';
import { Options } from 'ky';
import moment from 'moment';

import { tokenMaxAge, tokenMinAge } from '@/constants/api';
import { localStorageKeys } from '@/constants/localStorage';
import { query } from '@/constants/query';
import {
  // AuthRequest,
  // AuthResponse,
  BadgeRequest,
  BadgeResponse,
  MissionCheckResponse,
  SettingsHashResponse,
  SettingsResponse,
  SyncReponse,
  WalletRequest,
} from '@/types/api';
import { delay } from '@/utils';

import { Api } from '../api';

abstract class ServiceBase {
  api: Api = new Api({ options: this.options });

  get options(): Options {
    return {};
  }

  async auth() {
    // const response = await this.api.post<AuthRequest, AuthResponse>(
    //   '/auth',
    //   {
    //     auth: '',
    //   },
    //   {
    //     timeout: 30000,
    //   },
    // );
    // this.setToken(response.token);
  }

  async refreshToken(retryCount = 0) {
    try {
      const lastAuth = localStorage.getItem(localStorageKeys.tokenExp);
      const token = Cookies.get(query.auth);
      console.log('init with token', token);

      const duration = moment.duration(moment(lastAuth).diff(moment()));
      if (duration.asMinutes() > tokenMaxAge - tokenMinAge && lastAuth && token)
        return;

      await this.auth();
    } catch (e) {
      if (retryCount >= 3) throw e;
      await delay(2000);
      await this.refreshToken(retryCount + 1);
      throw e;
    }
  }

  setToken(token: string) {
    if (!token) return;

    const expDate = moment().add(tokenMaxAge, 'minutes').toDate();

    Cookies.set(query.auth, token, {
      expires: expDate,
    });
    localStorage.setItem(localStorageKeys.tokenExp, expDate.toISOString());
  }

  async sync() {
    const response = await this.api.post<object, SyncReponse>('/sync', {});
    return response;
  }

  async getSettings() {
    const hash = localStorage.getItem(localStorageKeys.hash) || '';
    const response = await this.api.get<SettingsResponse>(
      `/settings/${hash}.json`,
    );
    return response;
  }

  async getSettingsHash() {
    const response = await this.api.get<SettingsHashResponse>('/settings/hash');
    return response;
  }

  async setWallet(wallet: string) {
    const response = await this.api.post<WalletRequest, object>('/wallet', {
      wallet,
    });
    return response;
  }

  async checkMission(externalId: number) {
    const response = await this.api.post<object, MissionCheckResponse>(
      '/mission',
      {
        external_id: externalId,
      },
    );
    return response;
  }

  async buyBadge(externalId: number) {
    const response = await this.api.post<BadgeRequest, BadgeResponse>(
      '/badge',
      { external_id: externalId },
    );

    return response;
  }
}

export default ServiceBase;
